<template>
  <div class="container">
    <div class="main" v-html="counter"></div>
  </div>
</template>

<script>
import { getSmscode } from "../../apis/common";
import mobileType from "../../utils/mobileType";
import { tutorial } from "../../apis/order/order";

export default {
  data() {
    return {
      counter: null,
      // paramsData: {
      //   params: {
      //     areaCode: "110105",
      //     channel: "60100000",
      //     data: "",
      //     display: "1080*2340",
      //     platform: "1",
      //     softVersion: "1247",
      //     sysVersion: "HLK-AL10,10",
      //     token:
      //       "MTAxNzAwNTk6NzAwOjIwMjExMjAxMTUzMDE0NzI5OmZmZmZmZmZmLTk4MGItODIxOS1mZmZmLWZmZmZlZjA1YWM0YQ\u003d\u003d",
      //   },
      // },
      paramsData: {}
    };
  },
  created() {
    //Vue的方法给原生调用，则需要把方法挂在Window下面
    window.getDataFromNative = this.getDataFromNative;
  },
  mounted() {
    // this.paramsData = this.$apiFun.getPlatFromParams(this.$route.query);
    // let params = { ...this.paramsData.params };
    // if (params.platform != 99) {
    //   this.getDataFromNative();
    // } else {
    //   this.$apiFun.getUserInfoFromApp();
    // }
    // this.getData();
     this.paramsData = this.$apiFun.getPlatFromParams(this.$route.query);
      if (this.paramsData) {
        this.getDataFromNative();
      } else {
        this.$apiFun.getUserInfoFromApp();
      }
  },
  methods: {
    getDataFromNative(params) {
      if (!this.paramsData) {
          this.paramsData = this.$apiFun.getParamsIosAndroid(params, this.$route.query);
        }
      this.getInfoFun();
    },
    getInfoFun() {
      let params = { ...this.paramsData.params };
      let paramsOther = this.paramsData.paramsOther;
      console.log(params)
      console.log(paramsOther)
      
      // alert(JSON.stringify(paramsOther) )
      // alert(JSON.stringify(params) )
      // toLowerCase()
      this.getData();
    },

    // 获取数据
    async getData() {
      let params = { ...this.paramsData.params };
      params.data = {
        brandCode: this.paramsData.paramsOther.brand,
        // brandCode:"HUAWEI"
      };
      console.log(JSON.stringify(params))

      params.data = JSON.stringify(params.data);

      try {
        const data = await tutorial(params);
        if (data.code == 1) {
          console.log(JSON.parse(data.data))
          this.counter = JSON.parse(data.data).content;
        }
      } catch (error) {}
    },
  },
};
</script>
<style scoped lang="less">
</style>

